module.exports = __webpack_public_path__ + "img/settings1.1985964f.png";